import { createContext } from "react";
import type { Locale } from "~/core/i18n/index";

export interface I18n {
	locale: Locale;
	t: (key: string, vars?: Record<string, string | number>) => string;
	setLocale: (locale: Locale) => void;
}

// Message edits must not replace the context used by already mounted providers
// during Fast Refresh; otherwise consumers render a blank page until reload.
export const Context = createContext<I18n | null>(null);
